/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase'
], (UpgradeBase) => {

	/**
	* A clean up process to the css property of the layout spec to make sure the css styles are not duplicated.
	**/

	class DuplicateLayoutCssPropUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1301;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			return Promise.resolve()
				.then(() => {
					if (spec && spec.layout) {
						this._upgradeLayout(spec.layout);
					}
					return spec;
				});
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_upgradeLayout(layout) {
			if (layout.items) {
				// Recursively upgrade child layouts
				for (var item of layout.items) {
					this._upgradeLayout(item);
				}
			}
			this._upgradeCssProp(layout);
		}

		_upgradeCssProp(layout) {
			if (layout.css){
				layout.css = layout.css.split(' ').filter(function(style,index,allStyles){
					return index === allStyles.indexOf(style);
				}).join(' ').trim();
			}
		}

	}
	return new DuplicateLayoutCssPropUpgrade();
});
